// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__26-ww","paramInput":"JobSimulator_paramInput__12U6_","input":"JobSimulator_input__26mjz"};